// This is duplicated in embed.ts, if you add something here, add there as well
export enum WidgetMessageType {
	IDENTIFY_USER = 'identify-user',
	SEND_CHAT_MESSAGE = 'send-chat-message',
	CLEAR_CHATS = 'clear-chats',
	ON_CHAT_LOADED = 'on-chat-loaded',
	SET_CUSTOM_FIELDS = 'set-custom-fields',
	ON_CHAT_STARTED = 'on-chat-started',
	CHAT_MESSAGE_RECEIVED = 'chat-message-received',
	GO_TO_CHAT_ROOM = 'go-to-chat-room',
	GO_TO_CHAT_CONTACT_PAGE = 'go-to-chat-contact-page',
	GO_TO_CHAT_CLOSED_VIEW = 'go-to-chat-closed-view',
	CLOSE_WIDGET = 'close-widget',
	SET_CUSTOM_KB_HEADER = 'set-custom-kb-header',
	SET_CUSTOM_HOME_PAGE = 'set-custom-home-page',
	SET_CUSTOM_HERO_HTML = 'set-custom-hero-html',
	AUTHENTICATOR_ADDED = 'authenticator-added',
	VIEW_LOADED = 'view-loaded',
	AUTHENTICATION_REQUEST = 'authentication-request',
	AUTHENTICATION_RESPONSE = 'authentication-response',
	OVERRIDE_GREETING_MESSAGE = 'override-greeting-message',
	ACTIVE_CHAT_COUNT = 'active-chat-count'
}

export interface IdentifyUserMessage {
	type: WidgetMessageType.IDENTIFY_USER;
	data: {
		userData: Partial<{name: string, email: string}>,
		formTitle?: string
	};
}

export interface SendChatMessage {
	type: WidgetMessageType.SEND_CHAT_MESSAGE;
	data: {
		content: string
	};
}

export interface ClearChatsMessage {
	type: WidgetMessageType.CLEAR_CHATS;
	data: {endExistingChat?: boolean};
}

export interface OnChatLoadedMessage {
	type: WidgetMessageType.ON_CHAT_LOADED;
	data: {};
}

export interface AuthenticatorAddedMessage {
	type: WidgetMessageType.AUTHENTICATOR_ADDED;
	data: {};
}

export interface ViewLoadedMessage {
	type: WidgetMessageType.VIEW_LOADED;
	data: {};
}

export interface AuthenticationRequestMessage {
	type: WidgetMessageType.AUTHENTICATION_REQUEST;
	data: {};
}

export interface AuthenticationResponseMessage {
	type: WidgetMessageType.AUTHENTICATION_RESPONSE;
	data: {token: string};
}

export interface OnChatStarted {
	type: WidgetMessageType.ON_CHAT_STARTED;
	data: {ticketId: string};
}

export interface ChatMessageReceived {
	type: WidgetMessageType.CHAT_MESSAGE_RECEIVED;
	data: {};
}

export interface CloseWidget {
	type: WidgetMessageType.CLOSE_WIDGET;
	data: {};
}

export type ChatRoomPreviewMode = 'content' | 'during-hours' | 'outside-hours';

export interface PreviewGoToChatMessage {
	type: WidgetMessageType.GO_TO_CHAT_ROOM;
	data: {previewMode: ChatRoomPreviewMode};
}

export interface PreviewNavigationMessage {
	type: WidgetMessageType.GO_TO_CHAT_CONTACT_PAGE | WidgetMessageType.GO_TO_CHAT_CLOSED_VIEW;
	data: {};
}

export interface SetCustomFieldsMessage {
	type: WidgetMessageType.SET_CUSTOM_FIELDS;
	data: {customFields: {[key: string]: string}};
}

export interface SetCustomKbHeaderMessage {
	type: WidgetMessageType.SET_CUSTOM_KB_HEADER;
	data: {headerHtml: string};
}

export interface SetCustomHomePageMessage {
	type: WidgetMessageType.SET_CUSTOM_HOME_PAGE;
	data: {homePageHtml: string};
}

export interface SetCustomHeroHtmlMessage {
	type: WidgetMessageType.SET_CUSTOM_HERO_HTML;
	data: {heroHtml: string};
}

export interface OverrideGreetingMessage {
	type: WidgetMessageType.OVERRIDE_GREETING_MESSAGE;
	data: {greetingMessage: string};
}

export type WidgetMessage = IdentifyUserMessage | SendChatMessage | ClearChatsMessage | PreviewNavigationMessage
	| CloseWidget | OnChatLoadedMessage | SetCustomFieldsMessage | OnChatStarted | OverrideGreetingMessage
	| PreviewGoToChatMessage | SetCustomKbHeaderMessage | SetCustomHomePageMessage | SetCustomHeroHtmlMessage
	| AuthenticatorAddedMessage | ViewLoadedMessage | AuthenticationRequestMessage | AuthenticationResponseMessage;
